export default __webpack_public_path__ + "static/media/icons-document.18dd3c50.svg";